module.exports = "<p>\n  route-view-base works!\n</p>\n"